


















import { Component, Prop, Vue, Provide } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import TopHeader from "./top-header.vue";
import SideNav from "./side-nav.vue";

const user = namespace("user");
const app = namespace("app");
const base = namespace("base");
@Component({
  components: { TopHeader, SideNav }
})
export default class Layout extends Vue {
  @user.Getter isLogin;
  @base.Action getNewOrderMessage;
  @app.State pbpx;
  @app.State orderPushState;
  isRouterAlive: boolean = true;
  @Provide()
  refresh = this.reload;
  created() {
    if (!this.isLogin) {
      this.$router.push("/login");
    }
    this.loopGetMsg();
  }
  reload() {
    this.isRouterAlive = false;
    this.$nextTick(function() {
      this.isRouterAlive = true;
    });
  }
  destroyed() {
    // 销毁定时器
    this.timerId && clearInterval(this.timerId);
  }
  playSpeek() {
    (document.getElementById("audios") as any).play();
  }
  pushMessage(orderNo, messageId) {
    this.createNotice(orderNo, messageId);
    if (this.orderPushState) {
      this.playSpeek();
    }
  }
  msgText: string = "";
  openMsgIds: any[] = [];
  timerId: any = 0;
  loopGetMsg() {
    let query = () => {
      this.getNewOrderMessage().then(data => {
        if (data.data.list && data.data.list.length > 0) {
          data.data.list.forEach((item, index) => {
            if (!this.openMsgIds.includes(item.messageId)) {
              setTimeout(() => {
                this.pushMessage(item.orderNo, item.messageId);
              }, index * 1500);
            }
          });
        }
      });
    };
    setTimeout(query, 1000);
    this.timerId = setInterval(query, 10000);
  }
  createNotice(orderNo, messageId?) {
    this.openMsgIds.push(messageId);
    const h = this.$createElement;
    this.$notify({
      title: `${this.$t("layout.new-order")}：${orderNo}`,
      customClass: "new-order-notice",
      message: h("span", { class: "order-num", style: "" }, this.$t("layout.new-order-tips") as string),
      duration: 0,
      position: "bottom-right"
    });
  }
}
